import styled from 'styled-components';

export const StyledPriceDetailContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;

	.header-section {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.title-section {
		display: flex;
		flex-direction: column;
	}

	.price-list {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}

	.rate-container {
		display: flex;
		flex-direction: column;
	}

	.rate-row {
		display: flex;
		flex-direction: row;
	}
`;

export const SubtotalStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;

	.subtitle {
		svg {
			flex-shrink: 0;
		}
	}
`;

export const RateSectionContainerStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	button {
		align-self: flex-start;
	}
`;
